/**
 * External dependencies
 */
import React from "react";

/**
 * Internal dependencies
 */
import { Page, ProductCard, CategoryHeader } from "../components";
import { getFromQueryString } from "../utilities";

export default function SubCategoryPage(props) {
  const { productsInSubCat } = props.pageContext;
  const { search } = props.location;
  return (
    <Page className={"CatergoriesPage"} title={"Categories"}>
      <CategoryHeader
        product={productsInSubCat[0]}
        visitorName={getFromQueryString(search, "mi_name")}
      />
      <section
        style={{ paddingTop: "30px", paddingBottom: "130px" }}
        className="featured"
      >
        <div className="container">
          <div className="row">
            {productsInSubCat.map((product, key) => {
              return <ProductCard key={key} product={product} />;
            })}
            <br />
          </div>
        </div>
      </section>
    </Page>
  );
}
